export { Lottery } from '@/common/cms/modules/lottery/module/'
export { templateSlotMachineVue } from '@/common/cms/modules/lottery/template/slotMachine'
export { templateSudokuMachineVue } from '@/common/cms/modules/lottery/template/sudokuMachine'

export { LotteryList} from '@/common/cms/modules/lotteryList/module'
export { templateLotteryListVue } from '@/common/cms/modules/lotteryList/template/lotteryList'
export { templateCouponLotteryVue } from '@/common/cms/modules/lotteryList/template/couponLottery'
